import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	addRequestType: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.issue-types.add-request-type-dropdown.add-request-type',
		defaultMessage: 'Add request type',
		description: 'Opens a dropdown menu with two options.',
	},
	createFromTemplate: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.issue-types.add-request-type-dropdown.create-from-template',
		defaultMessage: 'Create from template',
		description: 'Item in a dropdown menu. Creates a new request type from a template.',
	},
	createCustom: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.issue-types.add-request-type-dropdown.create-custom',
		defaultMessage: 'Create blank',
		description: 'Item in a dropdown menu. Creates a new request type from scratch.',
	},
	maxFieldsLimitReachedTooltip: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.issue-types.add-request-type-dropdown.max-fields-limit-reached-tooltip',
		defaultMessage:
			"You've reached the field limit for this project. Select 'Create blank' to reuse existing fields.",
		description: 'Tooltip for the "Create from template" menu item.',
	},
});
